import { EVOtherEntitiesPageContent } from 'components/eventView/pages/EVOtherEntitiesPageContent';
import { EventEntityDefinition } from 'components/eventView/pages/eventData';
import { SplitHeader } from 'components/guide/split/SplitHeader';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    entityDefinition: EventEntityDefinition;
}

export const EVOtherEntitiesPagePC = (props: Props) => {
    const entityDefinition = props.entityDefinition;

    return (
        <S_EVOtherEntitiesPagePC id={entityDefinition.id} className={props.className}>
            <S_SplitHeader entityDefinition={entityDefinition} />
            <EVOtherEntitiesPageContent entityId={entityDefinition.id} />
        </S_EVOtherEntitiesPagePC>
    );
};

const S_EVOtherEntitiesPagePC = styled.div`
    overflow-y: hidden;
`;

const S_SplitHeader = styled(SplitHeader)`
    margin: 60px 0 60px 0;
`;
